import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { PredictiveSearch, SearchService } from 'src/app/services/search-service';

@Component({
  selector: 'pla-new-search-input',
  templateUrl: './new-search-input.component.html',
  styleUrls: ['./new-search-input.component.scss'],
})
export class NewSearchInputComponent implements OnInit {
  @Input('searchTrigger') public searchTrigger: EventEmitter<void> =
    new EventEmitter<void>();
  @Input() public maxLength: number = 20;
  @Input() public customChangerClasses: string = '';
  @Input() public changingPlaceholder: boolean = false;
  @Input() public fixedHeight: boolean = true;
  @Input() public weight: string = 'fw-bolder';
  @Input() public defaultInput: string = '';
  @Input() public internalRouting: boolean = true;
  @Input() public emitOnInput: boolean = false;
  @Output() public searchEvent: EventEmitter<string> = new EventEmitter<string>();
  @Input() public route: string = 'search-results/'
  @Input() public disabled: boolean = false;
  public focused: boolean = false;
  public searchInput: string;
  @Input() public canUsePredictive: boolean = false;
  @Input() public placeholder: string = 'What can we find for you?';
  @Input() public searchTexts: string[] = [
    'Name',
    'Initials',
    'Place',
    'Team',
    'Date',
    'Vehicle',
    'Brand'
  ];
  private debounceTimer: number = -1;

  constructor(private router: Router, private searchService: SearchService) { }

  ngOnInit(): void {
    this.searchInput = this.defaultInput.toUpperCase();
    this.searchTrigger.subscribe(() => {
      if (this.internalRouting) this.internalRoute()
      this.searchEvent.emit(this.searchInput);
    });
  }

  public KeyDown(event: KeyboardEvent): void {
    if (event.code !== 'Enter' && this.emitOnInput) { this.DebounceInput() }
    if (event.code === 'Enter') {
      event.stopImmediatePropagation();
      if (this.internalRouting) this.internalRoute();
      this.searchEvent.emit(this.searchInput);
    }
  }

  private internalRoute(): void {
    this.predictSearch(this.searchInput, (isPlate: boolean) => {
      this.router.navigate([`${isPlate && this.canUsePredictive ? 'compare/' : this.route}${this.searchInput}`]);
    });
  }

  private predictSearch(term: string, callback: (isPlate: boolean) => void): void {
    this.searchService.getPredictiveSearch(
      term,
      (_: PredictiveSearch[]) => {
        callback(_ != null && _.length > 0);
      }
    );
  }

  private DebounceInput(): void {
    window.clearTimeout(this.debounceTimer)
    this.debounceTimer = window.setTimeout(() => {
      this.searchEvent.emit(this.searchInput);
    }, 700)
  }

  public FocusElement(): void {
    document.getElementById('search-input').focus();
  }

  public SetFocus(value: boolean): void {
    this.focused = value;
  }
}
